import React from 'react';
import coinplug_logo from 'assets/coinplug-logo-horizo.png';
import new_release from 'assets/new_releases-24px.svg'
import * as Styles from 'pages/error/styles';

// Page error (페이지명은 추후에 바뀔 수 있음)
class error extends React.Component {
  render() {
  return (
    <Styles.PageLayout>
      <Styles.GridLayout>

        {/* 최상단 coinplug logo */}
        <Styles.LogoContainer>
          <Styles.Logo src={coinplug_logo} alt="error-coinplug-logo" />
        </Styles.LogoContainer>

        {/* 에러 아이콘 */}
        <Styles.IconContainer>
          <Styles.Icon src={new_release} alt="icon"></Styles.Icon>
        </Styles.IconContainer>

        {/* 샘플 텍스트 */}
        <Styles.Paragraph>
          Message of the error
        </Styles.Paragraph>

        {/* Back button */}
        <Styles.BackButtonContainer>
          <Styles.BackButtonWrapper>
            <Styles.BackButton onClick={onClickBackButton}> Back </Styles.BackButton>
          </Styles.BackButtonWrapper>
        </Styles.BackButtonContainer>
      </Styles.GridLayout>
    </Styles.PageLayout>
  )}
}

// TODO: on click longin button.
const onClickBackButton = () => {
  console.log("Login button of error page is clicked.")
}

export default error